import React, { useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import { Container, Row, Col } from "react-bootstrap";
import Ticker from "react-ticker";
import "./difference.css";
import Easy from "../assets/easy.png";
import Instant from "../assets/instant.png";
import Rates from "../assets/rates.png";
import Secure from "../assets/secure.png";
import Bitcoin from "../assets/bitcoin.png";
import USDT from "../assets/usdt.png";
import Eth from "../assets/Eth.png";
import Coin from "../assets/Coin.png";
import useFetch from "../../hooks/useFetch";

export default function Difference() {
  const { response: rates } = useFetch();
  const [EthValues, setEthValues] = useState("");
  // const [EthBValues, setEthBValues] = useState("");
  const [BtcValues, setBtcValues] = useState("");
  // const [BtcBValues, setBtcBValues] = useState("");
  const [LtcValues, setLtcValues] = useState("");
  // const [LtcBValues, setLtcBValues] = useState("");
  const [UsdtValues, setUsdtValues] = useState("");
  // const [UsdtBValues, setUsdtBValues] = useState("");
  useEffect(() => {
    if (rates.length > 0) {
      setEthValues(rates.filter((el) => el.Crypto === "ETH")[0].Sell);
      // setEthBValues(rates.filter((el) => el.Crypto === "ETH")[0].Buy);
      setBtcValues(rates.filter((el) => el.Crypto === "BTC")[0].Sell);
      // setBtcBValues(rates.filter((el) => el.Crypto === "BTC")[0].Buy);
      setLtcValues(rates.filter((el) => el.Crypto === "LTC")[0].Sell);
      // setLtcBValues(rates.filter((el) => el.Crypto === "LTC")[0].Buy);
      setUsdtValues(rates.filter((el) => el.Crypto === "USDT")[0].Sell);
      // setUsdtBValues(rates.filter((el) => el.Crypto === "USDT")[0].Buy);
    }
  }, [rates]);
  return (
    <div className="px-0">
      <div className="difference-page-wrapper">
        <div className="difference-caption-section">
          <Col md={11} className="medText">
            <Fade delay={250}>
              <div className="float-right leftText">
                We make sure every payment is <br className="dissolve" />
                capitalized on effected management <br className="dissolve" />
                and this is what we stand for
              </div>
            </Fade>
          </Col>
        </div>
        <div className="difference-caption-features">
          <Col md={{ span: 10, offset: 1 }}>
            <Fade delay={250}>
              <p className="mdText b7 blueText pb-3">Why we are different</p>
            </Fade>
            <Row>
              <Col md={6} sm={12}>
                <div className="d-flex">
                  <span>
                    <img src={Rates} alt="" className="bts-desc-icon" />
                  </span>
                  <span className="ml-3">
                    <p className="lightBlue mediumFont">Sweet Rates</p>
                    <span className="smallText lightText">
                      We provide competitive market rates that give you a great
                      deal, whether you’re buying or selling
                    </span>
                  </span>
                </div>
              </Col>
              <Col md={6}  sm={12}>
                <div className="d-flex">
                  <span>
                    <img src={Easy} alt="" className="bts-desc-icon" />
                  </span>
                  <span className="ml-3">
                    <p className="lightBlue mediumFont">Easy Trade</p>
                    <span className="smallText lightText">
                      Using Bitmasta is simple and straightforward. Just lock in
                      your email and complete your trade in only a few steps
                    </span>
                  </span>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className="d-flex">
                  <span>
                    <img src={Instant} alt="" className="bts-desc-icon" />
                  </span>
                  <span className="ml-3">
                    <p className="lightBlue mediumFont">Instant Service</p>
                    <span className="smallText lightText">
                      Our trades go through at the speed of light. Once we
                      receive and confirm payment, we will fund your account
                      instantly
                    </span>
                  </span>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className="d-flex">
                  <span>
                    <img src={Secure} alt="" className="bts-desc-icon" />
                  </span>
                  <span className="ml-3">
                    <p className="lightBlue mediumFont">Secure Platform</p>
                    <span className="smallText lightText">
                      Our trading platform is entirely safe and secure. Rest
                      assured that all your transactions will be treated with
                      the highest confidentiality.
                    </span>
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
        </div>
      </div>

      <Row className="justify-content-center bts-coin-rates sm-d-n">
        <Container className="">
          <Row>
            <Col md={3}>
              <div className="d-flex space-b">
                <span>
                  <img src={Bitcoin} alt="" className="image" />
                </span>
                <span className="bts-ask-amount pt-2 ml-3">
                  {/* <div className="b7">We Buy # {BtcBValues}/$</div> */}
                  <div className="b7">We Sell (Coming soon)</div>
                  <div className="lightBlue smallText b6 pt-1">
                    We Buy {BtcValues}/$
                  </div>
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex space-b">
                <span>
                  <img src={USDT} alt="" className="image" />
                </span>
                <span className="bts-ask-amount pt-2 ml-3">
                  {/* <div className="b7">We Buy # {UsdtBValues}/$</div> */}
                  <div className="b7">We Sell (Coming soon)</div>
                  <div className="lightBlue smallText b6 pt-1">
                    We Buy {UsdtValues}/$
                  </div>
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex space-b">
                <span>
                  <img src={Eth} alt="" className="image" />
                </span>
                <span className="bts-ask-amount pt-2 ml-3">
                  {/* <div className="b7">We Buy # {EthBValues}/$</div> */}
                  <div className="b7">We Sell (Coming soon)</div>

                  <div className="lightBlue smallText b6 pt-1">
                    We Buy {EthValues}/$
                  </div>
                </span>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex space-b">
                <span>
                  <img src={Coin} alt="" className="image" />
                </span>
                <span className="bts-ask-amount pt-2 ml-3">
                  {/* <div className="b7">We Buy # {LtcBValues}/$</div> */}
                  <div className="b7">We Sell (Coming soon)</div>

                  <div className="lightBlue smallText b6 pt-1">
                    We Buy {LtcValues}/$
                  </div>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </Row>
      <Container className="mintBlueBg bd-d-n pt-2 pb-2">
        <div>
          <Ticker speed={4}>
            {({ index }) => (
              <div className="d-flex">
                <div style={{ width: 300 }}>
                  <div className="d-flex space-b">
                    <span>
                      <img src={Bitcoin} alt="" className="image" />
                    </span>
                    <span className="bts-ask-amount pt-2 ml-3">
                      {/* <div className="b7">We Buy # {BtcBValues}/$</div> */}
                      <div className="b7">We Sell (Coming soon)</div>

                      <div className="lightBlue smallText b6 pt-1">
                        We Buy {BtcValues}/$
                      </div>
                    </span>
                  </div>
                </div>
                <div style={{ width: 300 }}>
                  <div className="d-flex space-b">
                    <span>
                      <img src={USDT} alt="" className="image" />
                    </span>
                    <span className="bts-ask-amount pt-2 ml-3">
                      {/* <div className="b7">We Buy # {UsdtBValues}/$</div> */}
                      <div className="b7">We Sell (Coming soon)</div>

                      <div className="lightBlue smallText b6 pt-1">
                        We Buy {UsdtValues}/$
                      </div>
                    </span>
                  </div>
                </div>
                <div style={{ width: 300 }}>
                  <div className="d-flex space-b">
                    <span>
                      <img src={Eth} alt="" className="image" />
                    </span>
                    <span className="bts-ask-amount pt-2 ml-3">
                      {/* <div className="b7">We Buy # {EthBValues}/$</div> */}
                      <div className="b7">We Sell (Coming soon)</div>
                      <div className="lightBlue smallText b6 pt-1">
                        We Buy {EthValues}/$
                      </div>
                    </span>
                  </div>
                </div>
                <div style={{ width: 300 }}>
                  <div className="d-flex space-b">
                    <span>
                      <img src={Coin} alt="" className="image" />
                    </span>
                    <span className="bts-ask-amount pt-2 ml-3">
                      {/* <div className="b7">We Buy # {LtcBValues}/$</div> */}
                      <div className="b7">We Sell (Coming soon)</div>

                      <div className="lightBlue smallText b6 pt-1">
                        We Buy {LtcValues}/$
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Ticker>
        </div>
      </Container>
    </div>
  );
}
